import { render, staticRenderFns } from "./PdfViewr.vue?vue&type=template&id=42a7813e&scoped=true&"
import script from "./PdfViewr.vue?vue&type=script&lang=js&"
export * from "./PdfViewr.vue?vue&type=script&lang=js&"
import style0 from "./PdfViewr.vue?vue&type=style&index=0&id=42a7813e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a7813e",
  null
  
)

export default component.exports